module.exports = __webpack_public_path__ + "img/icon-desu.7a89024b.svg";